import PrivacyPolicy from '../pages/documents/PrivacyPolicy'

export const DocumentsRoutes = [
    {
        path: 'privacy-policy',
        element: <PrivacyPolicy />,
    },
]
